import $ from 'jquery';
import BasePropertyView from 'BasePropertyView.js'
import contentTemplate from 'report/properties/style/pie-slices.ejs';
import { pickerCfg } from 'pickerCfg';
import util from 'util/Util.js';
import themeService from 'ThemeService.js';

class StylePieSliceView extends BasePropertyView {

    initialize(opts) {
        this.options = opts || {};
        this.template = contentTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        // !! Use Specific ids for hooking events when possible !!
        this.events = {
            'change input[name=pieText]': 'updateAttributes',
            'change #sliceColor0Picker, #sliceColor1Picker, #sliceColor2Picker, #sliceColor3Picker, #sliceColor4Picker, #sliceColor5Picker, #sliceColor6Picker, #sliceColor7Picker': 'updateColorAttributes',
            'change #sliceColor0, #sliceColor1, #sliceColor2, #sliceColor3, #sliceColor4, #sliceColor5, #sliceColor6, #sliceColor7': 'updateColorAttributesWithValidation',
            'blur input[type=text]': 'lostFocus',
            'focus input[type=text]': 'getFocus'
        };

        this.loadFromProperties();

        return this;
    }

    loadFromProperties() {
        const prop = this.model.get('Property');
        const sliceColors = _.find(prop, function (obj) { return obj._id === 'sliceColors' });
        const sliceValues = _.find(prop, function (obj) { return obj._id === 'sliceValues' });

        let i = 0;
        let sign = '';
        _.forEach(sliceColors.Item, (item) => {
            sign = item._value.indexOf('#')> -1? '': '#';
            this.model.set('sliceColor' + i.toString(), sign + item._value, { silent: true });
            i++;
        });

        i = 0;
        _.forEach(sliceValues.Item, (item) => {
            this.model.set('pieText' + i.toString(), item._value, { silent: true });
            i++;
        });
    }

    updateProperty(name, value){
        const prop = this.model.get('Property');
        let sliceColors = _.find(prop, function (obj) { return obj._id === 'sliceColors' });
        let index = name.replace('sliceColor', '');
        index = index.replace('Picker', '');
        sliceColors.Item[parseInt(index)]._value = value.replace('#', '');
    }

    updateColorAttributesWithValidation(ev){
        const propName = ev.currentTarget.id;
        const propVal = ev.currentTarget.value;
        this.updateProperty(propName, propVal);
        super.updateColorAttributesWithValidation(ev);
    }

    updateColorAttributes(ev) {
        const propName = ev.currentTarget.id;
        const propVal = ev.currentTarget.value;
        this.updateProperty(propName, propVal);
        super.updateColorAttributes(ev);
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.id;
        const propVal = ev.currentTarget.value;

        const prop = this.model.get('Property');
        const sliceValues = _.find(prop, function (obj) { return obj._id === 'sliceValues' });

        const i = propName.replace('pieText', '');
        sliceValues.Item[i]._value = propVal.replace('#', '');

        this.model.set(propName, propVal);
    }


    render() {
        super.render();

        let props = this.model.toJSON();
        this.$el.html(this.template(props));

        this.delegateEvents();

        return this;
    }

}

export default StylePieSliceView;
